import { useState, useEffect } from "react"

export default function NumberField({ fieldName, label, onChange, isSubmitted, isRequired, defaultValue, customWidth }){

    const [textValue, setTextValue] = useState('')
    const [errorValue, setErrorValue] = useState('')

    useEffect(() => {
        checkNumber()
        checkRequired()

        onChange({
            fieldValue: Number(textValue),
            fieldName: fieldName,
            error: errorValue,
            isSubmitted: isSubmitted,
            isRequired: isRequired
        })
    }, [textValue, errorValue, isSubmitted])

    useEffect(() => {
        if (defaultValue) {
            setTextValue(defaultValue)
        }
    }, [defaultValue])

    const classNames = (...classes) => {
        return classes.filter(Boolean).join(' ')
    }
    const checkRequired = () => {
        console.info('tetvalue is ', textValue)
        if (isSubmitted && isRequired) {
            if (textValue?.toString()?.trim()?.length === 0) {
                return setErrorValue(`${fieldName} is required`)
            }
        }
    }

    const checkNumber = () => {
        if (isNaN(textValue)) {
            return setErrorValue(`${fieldName} must be a digit`)
        } else {
            return setErrorValue('')
        }
    }

    const onTextFieldChange = (ev) => {
        setTextValue(ev.target.value)
    }

    return <div className="mb-1">
        <label className="block text-gray-700 text-sm font-bold mb-2 text-left" >
            {label}
        </label>
        <input 
            className={classNames(
                errorValue ? 'border-red-500' : '',
                'shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline'
            )}
            style={{ width: customWidth ? customWidth : null}}
            type="text"
            value={textValue}
            onChange={onTextFieldChange}
             />
        {
            errorValue ? <p className="text-red-500 font-bold text-xs italic text-left"> {errorValue} </p> : null
        }
        
    </div>
}